/**
 * @module utils/prototypes
 */

/**
 * @typedef {{}} Object
 * @typedef {{}} Prototype
 */
import inherits from './inherits.js'

const { getPrototypeOf, prototype } = Object

/**
 * Yields each prototypes of an object() instance
 * @param {Object} object
 * @return {Generator<Prototype, null, Prototype>}
 */
export default function* (object) {
  if (inherits(object, prototype)) {
    throw new TypeError('Unable to extend a plain object')
  }
  
  let current = object
  
  while (current !== null) {
    current = getPrototypeOf(current)
    
    yield current
  }
  
  return null
}
